export const BOOKING_URL =
  'https://lakes-osteopathy.au4.cliniko.com/bookings?business_id=1461846366216004942'

export const NAV_LINKS = [
  { label: 'HOME', path: '/' },
  { label: 'SERVICES', path: '/services' },
  { label: 'PRICING', path: '/pricing' },
  { label: 'TEAM', path: '/team' },
  { label: 'CONTACT', path: '/contact' },
]

export const CONTACT_DETAILS = {
  phoneNumbers: [
    { label: 'Landi', number: '022 095 9334' },
    { label: 'Sambi', number: '027 539 9663' },
  ],
  email: 'lakesosteos@gmail.com',
  address: {
    location: 'Foot Mechanics',
    street: '1241 Eruera Street',
    city: 'Rotorua, 3010',
  },
}
